/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetCaptureImageParams,
  PostAssignCameraToBranchBody,
  PostGetCamerasListBody,
  PostSetCameraFlagsBody,
  PostUnassignCameraFromBranchBody,
} from ".././schemas";

import { customInstance } from "../../axios-instance";
import type { ErrorType, BodyType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const postGetCamerasList = (
  postGetCamerasListBody: BodyType<PostGetCamerasListBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/camera/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetCamerasListBody,
      signal,
    },
    options,
  );
};

export const getPostGetCamerasListQueryKey = (
  postGetCamerasListBody: PostGetCamerasListBody,
) => {
  return [`/api/camera/`, postGetCamerasListBody] as const;
};

export const getPostGetCamerasListQueryOptions = <
  TData = Awaited<ReturnType<typeof postGetCamerasList>>,
  TError = ErrorType<unknown>,
>(
  postGetCamerasListBody: PostGetCamerasListBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetCamerasList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostGetCamerasListQueryKey(postGetCamerasListBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postGetCamerasList>>
  > = ({ signal }) =>
    postGetCamerasList(postGetCamerasListBody, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postGetCamerasList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostGetCamerasListQueryResult = NonNullable<
  Awaited<ReturnType<typeof postGetCamerasList>>
>;
export type PostGetCamerasListQueryError = ErrorType<unknown>;

export function usePostGetCamerasList<
  TData = Awaited<ReturnType<typeof postGetCamerasList>>,
  TError = ErrorType<unknown>,
>(
  postGetCamerasListBody: PostGetCamerasListBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetCamerasList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetCamerasList>>,
          TError,
          Awaited<ReturnType<typeof postGetCamerasList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetCamerasList<
  TData = Awaited<ReturnType<typeof postGetCamerasList>>,
  TError = ErrorType<unknown>,
>(
  postGetCamerasListBody: PostGetCamerasListBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetCamerasList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetCamerasList>>,
          TError,
          Awaited<ReturnType<typeof postGetCamerasList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetCamerasList<
  TData = Awaited<ReturnType<typeof postGetCamerasList>>,
  TError = ErrorType<unknown>,
>(
  postGetCamerasListBody: PostGetCamerasListBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetCamerasList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostGetCamerasList<
  TData = Awaited<ReturnType<typeof postGetCamerasList>>,
  TError = ErrorType<unknown>,
>(
  postGetCamerasListBody: PostGetCamerasListBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetCamerasList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostGetCamerasListQueryOptions(
    postGetCamerasListBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postAssignCameraToBranch = (
  postAssignCameraToBranchBody: BodyType<PostAssignCameraToBranchBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/camera/assign`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postAssignCameraToBranchBody,
      signal,
    },
    options,
  );
};

export const getPostAssignCameraToBranchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAssignCameraToBranch>>,
    TError,
    { data: BodyType<PostAssignCameraToBranchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAssignCameraToBranch>>,
  TError,
  { data: BodyType<PostAssignCameraToBranchBody> },
  TContext
> => {
  const mutationKey = ["postAssignCameraToBranch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAssignCameraToBranch>>,
    { data: BodyType<PostAssignCameraToBranchBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postAssignCameraToBranch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAssignCameraToBranchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAssignCameraToBranch>>
>;
export type PostAssignCameraToBranchMutationBody =
  BodyType<PostAssignCameraToBranchBody>;
export type PostAssignCameraToBranchMutationError = ErrorType<unknown>;

export const usePostAssignCameraToBranch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAssignCameraToBranch>>,
      TError,
      { data: BodyType<PostAssignCameraToBranchBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAssignCameraToBranch>>,
  TError,
  { data: BodyType<PostAssignCameraToBranchBody> },
  TContext
> => {
  const mutationOptions = getPostAssignCameraToBranchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getCaptureImage = (
  params?: GetCaptureImageParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/camera/capture`, method: "GET", params, signal },
    options,
  );
};

export const getGetCaptureImageQueryKey = (params?: GetCaptureImageParams) => {
  return [`/api/camera/capture`, ...(params ? [params] : [])] as const;
};

export const getGetCaptureImageQueryOptions = <
  TData = Awaited<ReturnType<typeof getCaptureImage>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCaptureImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCaptureImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCaptureImageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaptureImage>>> = ({
    signal,
  }) => getCaptureImage(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCaptureImage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCaptureImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCaptureImage>>
>;
export type GetCaptureImageQueryError = ErrorType<unknown>;

export function useGetCaptureImage<
  TData = Awaited<ReturnType<typeof getCaptureImage>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetCaptureImageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCaptureImage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaptureImage>>,
          TError,
          Awaited<ReturnType<typeof getCaptureImage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCaptureImage<
  TData = Awaited<ReturnType<typeof getCaptureImage>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCaptureImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCaptureImage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaptureImage>>,
          TError,
          Awaited<ReturnType<typeof getCaptureImage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCaptureImage<
  TData = Awaited<ReturnType<typeof getCaptureImage>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCaptureImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCaptureImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCaptureImage<
  TData = Awaited<ReturnType<typeof getCaptureImage>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCaptureImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCaptureImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCaptureImageQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns restart_camera and restart_service flags.
Flags are reset to False after reading.
 * @summary Get camera flags by device_id and token from headers.
 */
export const getGetCameraFlags = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/camera/flags`, method: "GET", signal },
    options,
  );
};

export const getGetGetCameraFlagsQueryKey = () => {
  return [`/api/camera/flags`] as const;
};

export const getGetGetCameraFlagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGetCameraFlags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGetCameraFlags>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGetCameraFlagsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGetCameraFlags>>
  > = ({ signal }) => getGetCameraFlags(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGetCameraFlags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGetCameraFlagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGetCameraFlags>>
>;
export type GetGetCameraFlagsQueryError = ErrorType<unknown>;

export function useGetGetCameraFlags<
  TData = Awaited<ReturnType<typeof getGetCameraFlags>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetCameraFlags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGetCameraFlags>>,
          TError,
          Awaited<ReturnType<typeof getGetCameraFlags>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGetCameraFlags<
  TData = Awaited<ReturnType<typeof getGetCameraFlags>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetCameraFlags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGetCameraFlags>>,
          TError,
          Awaited<ReturnType<typeof getGetCameraFlags>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGetCameraFlags<
  TData = Awaited<ReturnType<typeof getGetCameraFlags>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetCameraFlags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get camera flags by device_id and token from headers.
 */

export function useGetGetCameraFlags<
  TData = Awaited<ReturnType<typeof getGetCameraFlags>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetCameraFlags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGetCameraFlagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Requires admin authentication.
 * @summary Set camera flags by device_id.
 */
export const postSetCameraFlags = (
  postSetCameraFlagsBody: BodyType<PostSetCameraFlagsBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/camera/flags`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postSetCameraFlagsBody,
      signal,
    },
    options,
  );
};

export const getPostSetCameraFlagsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSetCameraFlags>>,
    TError,
    { data: BodyType<PostSetCameraFlagsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSetCameraFlags>>,
  TError,
  { data: BodyType<PostSetCameraFlagsBody> },
  TContext
> => {
  const mutationKey = ["postSetCameraFlags"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSetCameraFlags>>,
    { data: BodyType<PostSetCameraFlagsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postSetCameraFlags(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSetCameraFlagsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSetCameraFlags>>
>;
export type PostSetCameraFlagsMutationBody = BodyType<PostSetCameraFlagsBody>;
export type PostSetCameraFlagsMutationError = ErrorType<unknown>;

/**
 * @summary Set camera flags by device_id.
 */
export const usePostSetCameraFlags = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSetCameraFlags>>,
      TError,
      { data: BodyType<PostSetCameraFlagsBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSetCameraFlags>>,
  TError,
  { data: BodyType<PostSetCameraFlagsBody> },
  TContext
> => {
  const mutationOptions = getPostSetCameraFlagsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postUnassignCameraFromBranch = (
  postUnassignCameraFromBranchBody: BodyType<PostUnassignCameraFromBranchBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/camera/unassign`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postUnassignCameraFromBranchBody,
      signal,
    },
    options,
  );
};

export const getPostUnassignCameraFromBranchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUnassignCameraFromBranch>>,
    TError,
    { data: BodyType<PostUnassignCameraFromBranchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUnassignCameraFromBranch>>,
  TError,
  { data: BodyType<PostUnassignCameraFromBranchBody> },
  TContext
> => {
  const mutationKey = ["postUnassignCameraFromBranch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUnassignCameraFromBranch>>,
    { data: BodyType<PostUnassignCameraFromBranchBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postUnassignCameraFromBranch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUnassignCameraFromBranchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUnassignCameraFromBranch>>
>;
export type PostUnassignCameraFromBranchMutationBody =
  BodyType<PostUnassignCameraFromBranchBody>;
export type PostUnassignCameraFromBranchMutationError = ErrorType<unknown>;

export const usePostUnassignCameraFromBranch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUnassignCameraFromBranch>>,
      TError,
      { data: BodyType<PostUnassignCameraFromBranchBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUnassignCameraFromBranch>>,
  TError,
  { data: BodyType<PostUnassignCameraFromBranchBody> },
  TContext
> => {
  const mutationOptions =
    getPostUnassignCameraFromBranchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postUploadCameraImage = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/camera/upload_image`, method: "POST", signal },
    options,
  );
};

export const getPostUploadCameraImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUploadCameraImage>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUploadCameraImage>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postUploadCameraImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUploadCameraImage>>,
    void
  > = () => {
    return postUploadCameraImage(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUploadCameraImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUploadCameraImage>>
>;

export type PostUploadCameraImageMutationError = ErrorType<unknown>;

export const usePostUploadCameraImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUploadCameraImage>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUploadCameraImage>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostUploadCameraImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
